export default __webpack_public_path__ + "static/media/wallet.50e2de80.svg";